import React, { useEffect, useState } from 'react';
import { Feedback, useSectionFeedback } from './sectionFeedback';

function toDateInputValue(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
}

export default function VacationSection({ data, saving, onSave, actions }) {
    const [vacationEndsAt, setVacationEndsAt] = useState(toDateInputValue(data?.vacationEndsAt));
    const { feedback, showFeedback } = useSectionFeedback();

    useEffect(() => {
        setVacationEndsAt(toDateInputValue(data?.vacationEndsAt));
    }, [data?.vacationEndsAt]);

    function handleDeactivate() {
        onSave(async () => {
            const result = await actions.saveVacation('');
            if (result.success) setVacationEndsAt('');
            showFeedback(result.success ? 'success' : 'error', result.success ? 'Vacation mode deactivated.' : result.error);
            return result;
        });
    }

    function handleSave() {
        onSave(async () => {
            const result = await actions.saveVacation(vacationEndsAt);
            showFeedback(result.success ? 'success' : 'error', result.success ? 'Vacation mode saved.' : result.error);
            return result;
        });
    }

    return (
        <div>
            <div className="sfm-section-header">
                <h2>Vacation Mode</h2>
                <p>Temporarily pause orders while keeping products visible on your storefront.</p>
            </div>
            <div className={data?.isOnVacation ? 'success' : 'info'}>
                {data?.isOnVacation ? 'Vacation mode is active.' : 'Vacation mode is inactive.'}
                {data?.isOnVacation && (
                    <> <a href="#" onClick={e => { e.preventDefault(); if (!saving) handleDeactivate(); }} style={{fontWeight:'bold'}}>Deactivate now.</a></>
                )}
            </div>
            <div className="group">
                <label htmlFor="sfm-vacation">Vacation Mode Ends At</label>
                <input
                    id="sfm-vacation"
                    type="date"
                    value={vacationEndsAt}
                    onChange={event => setVacationEndsAt(event.target.value)}
                    aria-describedby="sfm-vacation-help"
                />
                <p id="sfm-vacation-help" className="help">Set a future date to activate vacation mode. Shoppers will see a notice but can still browse your products. Clear the field or choose a past date to deactivate.</p>
            </div>
            <div className="sfm-save-row">
                <button type="button" className="button primary" onClick={handleSave} disabled={saving}>Save Vacation Mode</button>
                <Feedback feedback={feedback} />
            </div>
        </div>
    );
}
